import { UserPermission } from '../../users/models/user-permission.enum';

export const GenesysCloudEmailConversationsModulePermissions = [
  UserPermission.ConversationEmailAccept
];
